<template>
    <div>
        <v-dialog persistent v-model="dialog" max-width="700" height="400">
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">مقالات مرتبط</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false; choosenList = JSON.parse(JSON.stringify(choosenListHistory));" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text>
                    <v-autocomplete
                        append-inner-icon="search"
                        class="mb-4 bg-white"
                        :items="list.filter(x => !choosenList.some(y => y.id == x.id))"
                        :no-data-text="(search == null || search.length < 3) ? 'حداقل 3 حرف جستجو کنید' : 'موردی پیدا نشد'"
                        v-model:search="search"
                        :key="reloadInput"
                        item-title="name"
                        item-value="id"
                        label="جستجو عنوان مقاله"
                        style="position: sticky; top: 0; z-index: 300"
                        @update:modelValue="makeChoice"
                        @keyup="makeSearch"
                    ></v-autocomplete>
                    <div class="mt-3 d-flex align-center pa-2 rounded bg-blue-grey-lighten-5" v-for="(item, index) in choosenList">
                        <p class="text-meta flex-grow-1">{{ item.name.length > 40 ? `${item.name.substr(0, 40)}...` : item.name }}</p>
                        <div class="text-small px-2 user-select-none bg-secondary rounded-xl">{{ item.public ? 'عمومی' : item.user_group == 'employees' ? 'کاربران سازمانی' : item.user_group == 'customers' ? 'مشتریان' : 'کاربران سازمانی و مشتریان' }}</div>
                        <v-btn color="error" icon="delete" variant="text" @click="choosenList.splice(index, 1)"></v-btn>
                    </div>
                </v-card-text>
                <v-card-actions class="py-3 px-5 bg-white">
                    <v-btn color="success" variant="flat" @click="dialog = false; choosenListHistory = JSON.parse(JSON.stringify(choosenList));">ثبت اطلاعات</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" variant="text" @click="dialog = false; choosenList = JSON.parse(JSON.stringify(choosenListHistory));">بستن</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            dialog:false,
            reloadInput: true,
            search:null,
            list:[],
            choosenList:[],
            choosenListHistory:[],
        };
    },
    methods: {
        makeChoice(id) {
            let index = this.list.findIndex(x => x.id == id);
            if (index != -1)
                this.choosenList.push(this.list[index]);
            this.search = null;
            this.list.splice(index, 1);
            this.reloadInput = !this.reloadInput;
        },
        makeSearch(){
            if(this.search && this.search.length >= 3){
                this.$knowledgebaseArticleList({name: this.search}).then(res => {
                    if(res && res.status == 'OK')
                        this.list = res.data;
                })
            }
        },
        openDialog() {
            this.list = [];
            this.choosenListHistory = JSON.parse(JSON.stringify(this.choosenList));
            this.dialog = true;
        }
    }
};
</script>
